import React, { useState,useEffect } from "react";
import logo from "../../assets/images/logo.svg";
import styles from "./Footer.module.scss";
import award from "../../assets/images/awardImg.svg";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { MenuItem, Modal, Select } from "@mui/material";
import { useTranslation } from "react-i18next";
import { getLangFromPath } from "../../utils/getLangFromPath ";
import axios from 'axios'
const Footer = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  // const lang = location.pathname.split("/")[1];

  const handleChangeLanguage = (e) => {
    const newLang = e.target.value;
    const pathParts = location.pathname.split("/");
    pathParts[1] = newLang;
    const newPath = pathParts.join("/");
    i18n.changeLanguage(newLang);
    navigate(newPath);
  };
    const [about, setAbout] = useState();
    useEffect(() => {
  
          const fetchAboutUsData = async () => {
        const lang=getLangFromPath();
        const response = await axios.get(
          "https://eliteluxora.vps.webdock.cloud/api/about",
          {
            headers: {
              "Accept-Language": lang,
            },
          }
        );
        setAbout(response?.data);
      };
      fetchAboutUsData()
    }, []);
const lang=getLangFromPath();
  return (
    <div className={styles.footer}>
      <div className={styles.main}>
        <div className={styles.left}>
          <img src={logo} alt="" />
          <ul>
            <li>
              <b>{t("footer.elite_luxora")}</b>
              <div className={styles.links}>
                <Link to={`/${lang}/about-us`}>{t("footer.about_us")}</Link>
                <Link to={`/${lang}/contact-us`}>{t("footer.contact_us")}</Link>
                <Link to={`/${lang}/`}>{t("footer.properties")}</Link>
              </div>
            </li>
            {/* <li>
              <b>{t("footer.real_estate")}</b>
              <div className={styles.links}>
                <a href="">{t("footer.partner_hub")}</a>
                <a href="">{t("footer.pf_expert")}</a>
                <a href="">{t("footer.find_property")}</a>
              </div>
            </li> */}
            <li>
              <b>{t("footer.contact_us_text")}</b>
              <div className={styles.links}>
              {about?.social_media.instagram && (
                  <a
                  target="_blank"
                  href={`${about?.social_media?.instagram}`}
                >
                  {t("footer.instagram")}
                </a>
              )}

                  {about?.social_media.twitter && (
                  <a
                  target="_blank"
                  href={`${about?.social_media?.twitter}`}
                >
                  {t("footer.twitter")}
                </a>
              )}
           
           
                  {about?.social_media.facebook && (
                  <a
                  target="_blank"
                  href={`${about?.social_media?.facebook}`}
                >
                  {t("footer.facebook")}
                </a>
              )}
                  {about?.social_media.tiktok && (
                  <a
                  target="_blank"
                  href={`${about?.social_media?.tiktok}`}
                >
                  {t("footer.tiktok")}
                </a>
              )}
           
              </div>
            </li>
          </ul>
        </div>

        <div className={styles.awards}>
          <img src={award} alt="" />
          {/* <img src={award} alt="" /> */}
        </div>
      </div>
      <div className={styles.bottom}>
        <p>{t("copyright")}</p>
        <ul>
          <li>
            <div className="langSwitcher">
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={lang || "en"}
                label="Language"
                onChange={handleChangeLanguage}
                sx={{
                  padding: "8px 0px",
                  backgroundColor: "transparent",
                  border: "1px solid #E6E7EB",
                  opacity: 0.9,
                  borderRadius: 0,
                  cursor: "pointer",
                  fontSize: "14px",
                  height: "40px",
                  ".MuiSelect-select": {
                    padding: "8px 14px",
                  },
                  ".MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                }}
              >
                <MenuItem value="en">English</MenuItem>
                <MenuItem value="ae">UAE</MenuItem>
              </Select>
            </div>
          </li>
          {/* <li>
            <a href="">{t("footer.terms")}</a>
          </li>
          <li>
            <a href="">{t("footer.privacy")}</a>
          </li>
          <li>
            <a href="">{t("footer.cookies")}</a>
          </li> */}
        </ul>
      </div>
    </div>
  );
};

export default Footer;
